import React from 'react';
import styles from './Loader.module.scss';

const Loader = ({ loading = false, style, ...rest }) => {
  return (
    <div style={{ ...style, textAlign: 'center', padding: '2rem' }} {...rest}>
      {loading && <div className={styles.loader__spinner} />}
    </div>
  );
};

export default Loader;
